
namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class QuartersGrid extends Serenity.EntityGrid<QuartersRow, any> {
        protected getColumnsKey() { return QuartersColumns.columnsKey; }
        protected getDialogType() { return QuartersDialog; }
        protected getIdProperty() { return QuartersRow.idProperty; }
        protected getInsertPermission() { return QuartersRow.insertPermission; }
        protected getLocalTextPrefix() { return QuartersRow.localTextPrefix; }
        protected getService() { return QuartersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}